import CanvasJSReact from './canvasjs/canvasjs.react';
import { useEffect,useState } from 'react';
import { get } from './Api';
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;


export default function PurchaseChart({outletCode,skuCode}) {

    const [options,setOptions]=useState({
        animationEnabled: true,
        theme: "light2", // "light1", "light2", "dark1", "dark2"
        title: {
            text: ""
        },
        width: 400,
        axisY: {
            title: "Purchase Quantity",
            labelFormatter: addSymbols,
            scaleBreaks: {
                autoCalculate: true
            }
        },
        axisX: {
            title: "Month",
            labelAngle: 0
        },
        data: [{
            type: "column",
            dataPoints: [
                // { label: "2022-01", y: 10 },
                // { label: "2022-02", y: 20 },
                // { label: "2022-03", y: 30 },
                // { label: "2022-04", y: 40 },
                // { label: "2022-05", y: 50 },
                // { label: "2022-06", y: 60 }
            ]
        }]
    })

    const getStats = async () =>  {
       var accountId = userInfo.accountId;
       let category=""
       if(accountId.indexOf("jti")!=-1){
        category="&skufield=category";
       }
       if(accountId.indexOf("niinedemo")!=-1){
        category="&skufield=order";
       }
       return await get(`/smartbasket/history?skuCode=${skuCode}&outletCode=${outletCode}&environment=${userInfo.environment||"uat"}&lob=${userInfo.accountId}${category}`)          
    }

    useEffect(() => {
        getStats().then(out=>{
            console.log(out)
            var ops = {
                animationEnabled: true,
                theme: "light2", // "light1", "light2", "dark1", "dark2"
                title: {
                    text: ""
                },
                width: 400,
                axisY: {
                    title: "Purchase Quantity",
                    labelFormatter: addSymbols,
                    scaleBreaks: {
                        autoCalculate: true
                    }
                },
                axisX: {
                    title: "Month",
                    labelAngle: 0,
                    labelFontSize: 10
                },
                data: [{
                    type: "splineArea",
                    dataPoints:out.features.sort((a,b)=>new Date(Date.parse(a.creation_time)).getTime()-new Date(Date.parse(b.creation_time)).getTime()).map(h=>{return {"label":h.creation_time.split("T")[0],"y":h.piece_quantity}})
                }]
            }
            setOptions(ops);
        })
        

    },{})

    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }

    function addSymbols(e) {
        var suffixes = ["", "K", "M", "B"];
        var order = Math.max(Math.floor(Math.log(e.value) / Math.log(1000)), 0);

        if (order > suffixes.length - 1)
            order = suffixes.length - 1;

        var suffix = suffixes[order];
        return CanvasJS.formatNumber(e.value / Math.pow(1000, order)) + suffix;
    }


    return (
        <div>
            <CanvasJSChart options={options} style={{ width: "200px" }}
            // onRef={ref => chart = ref}
            />
            {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
        </div>
    );
}
